var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4454 1.55425C20.3795 -0.516782 17.0198 -0.516782 14.9539 1.55425L1.21862 15.2844C1.11123 15.3918 1.04476 15.5299 1.0243 15.6782L0.00668298 23.2157C-0.023999 23.4305 0.0527059 23.6453 0.201002 23.7936C0.328844 23.9214 0.507822 23.9981 0.6868 23.9981C0.717482 23.9981 0.748164 23.9981 0.778846 23.993L5.31978 23.3794C5.69819 23.3282 5.9641 22.9805 5.91296 22.6021C5.86183 22.2237 5.5141 21.9578 5.13569 22.0089L1.49476 22.4998L2.20556 17.243L7.73854 22.7759C7.86638 22.9038 8.04536 22.9805 8.22434 22.9805C8.40332 22.9805 8.58229 22.9089 8.71014 22.7759L22.4454 9.04577C23.4477 8.04349 24 6.71394 24 5.29745C24 3.88097 23.4477 2.55142 22.4454 1.55425ZM15.2198 3.24176L17.5261 5.54802L4.9925 18.0816L2.68624 15.7753L15.2198 3.24176ZM8.22945 21.3134L5.97433 19.0583L18.5079 6.52473L20.763 8.77986L8.22945 21.3134ZM21.7244 7.79292L16.2068 2.27528C16.9073 1.69743 17.7818 1.38039 18.7022 1.38039C19.7505 1.38039 20.7324 1.78948 21.4738 2.52585C22.2153 3.26221 22.6193 4.24915 22.6193 5.29745C22.6193 6.22302 22.3022 7.09235 21.7244 7.79292Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImage);
export default __webpack_public_path__ + "static/media/edit-image.d16f73b1.svg";
export { ForwardRef as ReactComponent };